module.exports = __webpack_public_path__ + "img/endCourt.e11e6d39.svg";